exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".client-item{position:relative;width:100%;height:0;padding-bottom:100%}.client-item:before{content:\"\";position:absolute;top:0;right:0;width:15%;height:15%;background-color:#fff;z-index:1}.client-item .image{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);max-width:140px;height:auto}@media (max-width:834px){.client-item .image{max-width:80px}}.client-item .circle{position:absolute;top:-5%;left:-5%;bottom:-5%;right:-5%;border-radius:50%;border:1px solid #dfe0e2}", ""]);

// exports
